import type {
	ElectricityMeterDetail,
	HeatMeterDetail,
	WaterMeterDetail,
} from "@/api/districts/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EmptyCell } from "@/components/ui/empty-cell";
import { Skeleton } from "@/components/ui/skeleton";
import { displayDate } from "@/lib/empty-value";

export type TypedData =
	| { kind: "woda"; data: WaterMeterDetail }
	| { kind: "cieplo"; data: HeatMeterDetail }
	| { kind: "energia"; data: ElectricityMeterDetail };

export function fmt(dt: string | null | undefined) {
	return displayDate(dt);
}

export function fmtDate(d: string | null | undefined) {
	return displayDate(d, "pl", { dateStyle: "short" });
}

export function DetailRow({
	label,
	value,
	wrap,
}: {
	label: string;
	value: React.ReactNode;
	wrap?: boolean;
}) {
	return (
		<div className="flex items-baseline justify-between gap-4 py-1">
			<span className="text-muted-foreground text-sm shrink-0">{label}</span>
			<span
				className={`font-mono text-sm font-medium text-right${wrap ? " min-w-0 break-all" : ""}`}
			>
				{value ?? <EmptyCell />}
			</span>
		</div>
	);
}

export function StatCard({
	label,
	value,
	isLoading,
}: {
	label: string;
	value: React.ReactNode;
	isLoading: boolean;
}) {
	return (
		<Card>
			<CardHeader className="pb-2">
				<CardTitle className="text-sm font-medium text-muted-foreground">
					{label}
				</CardTitle>
			</CardHeader>
			<CardContent>
				{isLoading ? (
					<Skeleton className="h-5 w-full" />
				) : (
					<p className="text-sm font-medium">{value ?? <EmptyCell />}</p>
				)}
			</CardContent>
		</Card>
	);
}
